import { BellRing, Share, X } from 'lucide-react';
import { isIos, isStandalone } from '../lib/push';

interface NotificationSetupProps {
  isBusy: boolean;
  onEnable: () => void;
  onDismiss: () => void;
}

export function NotificationSetup({ isBusy, onEnable, onDismiss }: NotificationSetupProps) {
  const needsIosInstall = isIos() && !isStandalone();

  return (
    <aside className="notification-card" aria-labelledby="notifications-title">
      <button className="icon-button notification-card__close" type="button" onClick={onDismiss} aria-label="Chiudi">
        <X size={20} />
      </button>
      <span className="notification-card__icon" aria-hidden="true">
        {needsIosInstall ? <Share size={25} /> : <BellRing size={25} />}
      </span>
      <div>
        <h2 id="notifications-title">{needsIosInstall ? 'Installa per ricevere gli avvisi' : 'Saprai quando si spostano'}</h2>
        <p>{needsIosInstall
          ? 'Su iPhone tocca Condividi → Aggiungi alla schermata Home, poi riapri L.O.C.U.S.'
          : 'Attiva le Push: riceverai un avviso ogni volta che qualcuno cambia luogo.'}</p>
      </div>
      {!needsIosInstall && (
        <button className="button button--secondary" type="button" onClick={onEnable} disabled={isBusy}>
          {isBusy ? 'Attivazione…' : 'Attiva notifiche'}
        </button>
      )}
    </aside>
  );
}
